import React from 'react'
import { Box } from '@mui/material'
import { Table } from 'Common/MUITable/MUITable'
import { useDropZoneContext } from './DropZone'

import { GridColDef } from '@mui/x-data-grid'

interface DataTabContentProps {
  data: Array<Record<string, unknown>>
  generatedColumns: GridColDef[]
}

export const DataTabContent: React.FC<DataTabContentProps> = ({
  data: _data,
  generatedColumns,
}) => {
  // You can access the context like this if needed
  const context = useDropZoneContext()

  return (
    <Box
      id="table-container-mui"
      sx={{
        width: '100%',
        height: '80%',
      }}
    >
      <Table
        disableRowSelectionOnClick
        rows={context.tableData ?? []}
        columns={generatedColumns ?? []}
        showCellVerticalBorder
        showColumnVerticalBorder
        pagination
        initialState={{
          pagination: { paginationModel: { pageSize: 15 } },
          density: 'compact',
        }}
        pageSizeOptions={[15, 50, 100]}
      />
    </Box>
  )
}

export default DataTabContent
